module.exports = __webpack_public_path__ + "img/avp_bck_alt_phablet@2x.b2a5ef4.jpg";